<template>
  <b-row align-v="end">
    <b-col>
      <b-form-group :label="trans('line_width')">
        <b-form-input type="number" min="0" v-model="line_width" @change="onChange" />
      </b-form-group>
    </b-col>
    <b-col>
      <b-form-group :label="trans('line_color')">
        <b-form-input :id="`spacer-line-color-${id || 'new'}`" v-model="line_color" />
      </b-form-group>
    </b-col>
    <b-col>
      <b-form-group :label="trans('margin_top')">
        <b-form-input type="number" min="0" v-model="margin_top" placeholder="20" @change="onChange" />
      </b-form-group>
    </b-col>
    <b-col>
      <b-form-group :label="trans('margin_bottom')">
        <b-form-input type="number" min="0" v-model="margin_bottom" :placeholder="(margin_top || 20)+''" @change="onChange" />
      </b-form-group>
    </b-col>
    <b-col>
      <b-form-group :label="trans('margin_left_right')">
        <b-form-input type="number" min="0" v-model="margin_left_right" placeholder="0" @change="onChange" />
      </b-form-group>
    </b-col>
  </b-row>
</template>

<script>
  import 'spectrum-colorpicker/spectrum.js'

  export default {
    props: {
      organization: Object,
      id: Number,
      meta: Object,
    },
    data() {
      let height = this.meta && this.meta.height ? this.meta.height : 40
      return {
        trans: trans,
        margin_top: this.meta && (this.meta.margin_top || this.meta.margin_top === 0) ? this.meta.margin_top : height/2,
        margin_bottom: this.meta && (this.meta.margin_bottom || this.meta.margin_bottom === 0) ? this.meta.margin_bottom : null,
        margin_left_right: this.meta && this.meta.margin_left_right ? this.meta.margin_left_right : null,
        line_width: this.meta && this.meta.line_width ? this.meta.line_width : 0,
        line_color: this.meta && this.meta.line_color ? this.meta.line_color : null,
      }
    },
    computed: {
      serialized() {
        return {
          margin_top: this.margin_top,
          margin_bottom: this.margin_bottom,
          margin_left_right: this.margin_left_right,
          line_width: this.line_width,
          line_color: this.line_color,
        }
      },
    },
    watch: {
      meta() {
        let height = this.meta && this.meta.height ? this.meta.height : 40
        this.margin_top = this.meta && (this.meta.margin_top || this.meta.margin_top === 0) ? this.meta.margin_top : height/2
        this.margin_bottom = this.meta && (this.meta.margin_bottom || this.meta.margin_bottom === 0) ? this.meta.margin_bottom : null
        this.margin_left_right = this.meta && this.meta.margin_left_right ? this.meta.margin_left_right : null
        this.line_width = this.meta && this.meta.line_width ? this.meta.line_width : 0
        this.line_color = this.meta && this.meta.line_color ? this.meta.line_color : null
      },
    },
    methods: {
      onChange() {
        this.$emit('meta', this.serialized)
      },
      onLineColorChange(color) {
        if (color._a == 0) {
          this.line_color = null
        } else {
          this.line_color = color ? color.toHexString() : this.line_color
        }
        this.onChange()
      },
      onLineColorMove(color) {
        if (color._a == 0) {
          this.line_color = null
        } else {
          this.line_color = color ? color.toHexString() : this.line_color
        }
        this.onChange()
      },
    },
    mounted() {
      $(`#spacer-line-color-${this.id || 'new'}`).spectrum({
        preferredFormat: "hex",
        showInput: true,
        cancelText: trans('cancel'),
        chooseText: trans('choose'),
        allowEmpty: true,
        showInitial: true,
        clickoutFiresChange: true,
        showButtons: false,
        showPalette: true,
        palette: _.fixPalette(_.uniq(_.compact(_.union(
          [this.organization.button_color, this.organization.button_text_color],
          this.organization.brand_colors,
          ['#333333', '#666666', '#999999'],
        )))),
        change: this.onLineColorChange.bind(this),
        move: this.onLineColorMove.bind(this),
      })
    },
  }
</script>